import React, { Component } from 'react';
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import "@syncfusion/ej2-base/styles/material.css";
import "@syncfusion/ej2-react-buttons/styles/material.css";
import "@syncfusion/ej2-react-popups/styles/material.css";
import "react-table-6/react-table.css";
import Loader from 'react-loader-spinner';
class SupportTeamWorkHours extends Component {
    constructor() {
        super();
        this.dialogClose = () => {
            this.setState({ hideupdateDialog: false, hideAddDialog: false, hideDeletePopup: false });
        };

        this.settings = { effect: 'Zoom', duration: 400, delay: 0, position: 'center' };

        this.addedButton = [{
            buttonModel: {
                content: 'OK',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.fetchWorkHoursApi()
                this.dialogClose();
                this.setState({
                })
            }
        }];


        //for delete dialog component ok click
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.deleteWorkHourApi(this.state.id)

                this.state.hideDeleteSuccessPopup = true

            }
        }
            , {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({
                    hideDeletePopup: false,
                    disabled: false
                });
            }
        }];

        //for delete success
        this.deleteSuccessbuttons = [{
            buttonModel: {
                content: 'Ok',
                cssClass: 'e-flat',
                isPrimary: true,

            },
            'click': props => {
                this.dialogInstance.hide();
                this.fetchWorkHoursApi()
                this.setState({ disabled: false })

            }
        }];

        this.state = {
            startTime: '',
            endTime: '',
            selectedReportType: '',
            showTrustedEmailId: false,
            items: [],
            trustedItems: [],
            value: [],
            trustedValue: [],
            error: null,
            trustedError: null,
            editedId: 0,
            fields:
            {

            },
            types: [],
            timeZone: null,
            hidden: false,
            hideAddDialog: false,
            hideupdateDialog: false,
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false,
            Username: '',
            Useremail: '',
            count: '',
            successResp: false
        }
        this.emailIdInList = [];
        this.trustedemailIdInList = [];
        this.afterDeleting = [];
        this.trustedEmailafterDeleting = [];
        this.allEmail = [];
    }
    componentDidMount() {
        setTimeout(() => {
            this.fetchWorkHoursApi();
        }, 0);

        var thisController = this;

        document.addEventListener("projectChanged", function (event) {
            thisController.projectId = event.projectId;
            thisController.fetchWorkHoursApi();
        });

    }
    editContent = event => {
        this.setState({ editedId: "-1" });
    }

    showPopup = () => {
        this.setState({
            hideDeletePopup: true
        })
    }





    notifyMsgFieldEmpty() {
        toast.dismiss();
        toast(<b ><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill all the data</b>, {
            position: "top-center"
        });

    }


    handleTimeZone = (e) => {
        this.state.editedId = "-1"
        this.fetchScheduleReportTypeApi();
    }


    saveWorkHoursApi = (props) => {

        let addController = this;
        var data = {
            projectId: localStorage.getItem("currentProjectId"),
            startTime: addController.state.startTime,
            endTime: addController.state.endTime
        }
        $.ajax({
            url: "/api/work-hours",
            async: false,
            method: 'POST',
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
                'Content-Type': 'application/json'

            },
            data: JSON.stringify(data),

            success: function (res) {
                if (res.success === true) {
                    addController.notifyAdd();
                    addController.fetchWorkHoursApi();
                    addController.state.editedId = 0;
                    addController.setState(addController.state);

                } else {
                    addController.notifyError(res.result);
                }
            },

            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });
    }



    notifyAdd() {
        toast.dismiss();
        toast(<b ><img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
            content="" />&nbsp;&nbsp;Support Team Work Hours Added Successfully</b>, {
            position: "top-center",

        });
    }

    notifyError(response) {
        toast.dismiss();
        toast(<b ><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            {response}</b>, {
            position: "top-center"
        });
    }








    fetchWorkHoursApi = () => {

        var fetchWorkController = this;
        $.ajax({
            url: "/api/work-hours",
            async: false,
            method: 'GET',
            data: {
                projectId: localStorage.getItem('currentProjectId')
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
            },

            success: function (res) {
                if (res.success === true) {
                    if (res.result[0] != null) {
                        fetchWorkController.state.startTime = res.result[0].startTime;
                        fetchWorkController.state.endTime = res.result[0].endTime;
                        fetchWorkController.state.id = res.result[0].id;


                        fetchWorkController.setState(fetchWorkController.state);
                    } else {
                        fetchWorkController.state.startTime = '';
                        fetchWorkController.state.endTime = '';
                        fetchWorkController.state.id = '';
                        fetchWorkController.setState(fetchWorkController.state);

                    }
                }
                else {
                    fetchWorkController.notifyError(res.result);
                }
            }
        });
    }



    deleteWorkHourApi = (id) => {
        let deleteRowViewController = this.state.data;
        let deleteApiViewController = this;
        var deleteConstructorVariables = this;

        if (id == "") {
            deleteConstructorVariables.notifyError("No Work Hour Data Found")
        } else {
            $.ajax({
                url: "/api/delete-work-hours/" + id,
                async: false,
                method: 'DELETE',
                headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
                success: function (res) {

                    if (res.success === true) {

                        deleteApiViewController.setState({ deleteRow: true });
                        deleteConstructorVariables.setState({ hideDeletePopup: false });
                        deleteConstructorVariables.fetchWorkHoursApi();
                        deleteConstructorVariables.state.editedId = 0;
                        deleteConstructorVariables.setState(deleteConstructorVariables.state);
                        deleteConstructorVariables.notifyDelete();
                    } else {
                        deleteRowViewController.NotifyError();
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/platform/";
                    }
                }
            });
        }


    }


    notifyDelete() {
        toast.dismiss();
        toast(<b ><img src="assets/images/done.svg"
            style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Working Hour Deleted Successfully</b>, {
            position: "top-center",

        });
    }







    handleChangeStartTime = (e) => {
        this.state.startTime = e.target.value;
        this.setState(this.state);
    }
    handleChangeEndTime = (e) => {
        this.state.endTime = e.target.value;
        this.setState(this.state);
    }
    render() {
        return (
            <div>

                <div>
                    {/* for email-css */}
                    <link rel="stylesheet" href="assets/css/scheduleReportStyle.css" />
                    {/* for toaster */}
                    <link rel="stylesheet" href="assets/css/ReactToastify.css" />

                    {/*for dialog component */}
                    <link href="assets/css/ej2-base.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                    <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                    <link href="assets/css/screenResolution.css" rel="stylesheet" />

                    <div className="content-header">
                        <h6 className="nav-item" style={{ color: '#282a65'}}>Support Team Working Hours</h6>
                    </div>


                    <div className="card-body p-0 mb-25">
                        <div className="tab-content col-12 p-0">
                            <div className="tab-pane active show" id="tab_1">
                                <div className="card card-primary mt-3">
                                    <form role="form" className="raiseTicketLable">
                                        <div className="card-body raise-form">
                                            <div className="row">
                                                <div className="col-sm-1.5">

                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6">

                                                </div>
                                                <div className="col-sm-6" Align='right'   >
                                                    <button type="button" className="btn btn-primary pull-right navyblue-btn"
                                                        onClick={this.editContent}
                                                        style={{
                                                            marginTop: '24px', width: '66px',
                                                            backgroundColor: '#282a65', color: 'white'
                                                        }}>Edit</button>


                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-6">
                                                    <div className="form-group">
                                                        <label className="col-12 pull-left " >Start Time</label>
                                                        <input disabled={(this.state.editedId == 0) ? true : false}
                                                            type="time" className="form-control col-11"
                                                            id="time" name="time" placeholder="Enter Time"
                                                            value=
                                                            {this.state.startTime}
                                                            style={{ width: '78%', cursor: 'pointer', border: '1px solid #D2D4DC', borderRadius: "4px" }}
                                                            onChange={this.handleChangeStartTime} />
                                                    </div>

                                                </div>

                                                <div className="col-sm-6">
                                                    <div className="form-group">
                                                        <label className="col-12 pull-left " >End Time</label>
                                                        <input disabled={(this.state.editedId == 0) ? true : false}
                                                            type="time" className="form-control col-11"
                                                            id="time" name="time" placeholder="Enter Time"
                                                            value=
                                                            {this.state.endTime}
                                                            style={{ width: '78%', cursor: 'pointer', border: '1px solid #D2D4DC', borderRadius: "4px" }}
                                                            onChange={this.handleChangeEndTime} />
                                                    </div>

                                                </div></div>
                                            <div>
                                                <div>
                                                    <button type="button" className="btn btn-primary pull-right navyblue-btn"
                                                        hidden={(this.state.editedId == 0) ? true : false}

                                                        onClick={this.showPopup}
                                                        style={{ marginTop: '24px', width: '70px', marginRight: "-80px" }}
                                                    >Delete</button>
                                                </div>
                                                <div>
                                                    <button type="button" className="btn btn-primary pull-right navyblue-btn"
                                                        hidden={(this.state.editedId == 0) ? true : false}
                                                        onClick={this.saveWorkHoursApi} style={{ marginTop: '24px', width: '66px' }}>Save</button>
                                                    {/* </div> */}
                                                </div>
                                            </div>
                                        </div>
                                        <ToastContainer className="Toast-at-center" />


                                        {/* Dialog Component For Deletion Confirmation */}
                                        <DialogComponent width='400px' animationSettings={this.settings}
                                            header='Working Hours' showCloseIcon={true} buttons={this.buttons}
                                            ref={dialog => this.dialogInstance = dialog}
                                            visible={this.state.hideDeletePopup} close={this.dialogClose}>
                                            <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                                                content="" />&nbsp;Do you want to delete the Working Hours?<br />Note: Press 'Yes' to delete or press 'No' to decline.


                                        </DialogComponent>


                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    }
}
export default SupportTeamWorkHours;


// WEBPACK FOOTER //
// ./src/projectmgmt/settings/team/SupportTeamWorkHours.js